











































































import _ from 'lodash';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Partner } from '@/modules/kartoteka/partner';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { OrganizacniJednotky } from '@/modules/administrace/organizacniJednotky';
import { BankovniUcet } from '@/modules/ciselnik/firemni/bankovniUcet';

import { mapMutationsDvm } from '@/main/pages';

import { PageMode } from '@/main/utils/pageMode';

import { DefaultCurrency } from '@/modules/servis/zakazka/components/AdvancePay/constants';

import { store } from '../store/edit';
import { types } from '../store/types';

import { NAME, TAB_NAMES, TABS2, TABS3, PlannerStepInterval, PlannerStartingTime, PlannerEndingTime} from '../constants';
import { number } from '@storybook/addon-knobs';

export default PageModeMixin.extend({
	name: 'Planner',
	components: {
		DealerSelect: OrganizacniJednotky.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		PartnerSelect: Partner.components.Select,
		BankovniucetSelect: BankovniUcet.components.Select,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			tabNames: TAB_NAMES,
			disabledSeconds: [1, 59],
			IsVisible: false,
		};
	},
	computed: {	
		StartPlannerTime: {
			get() {
				return this.PlannerStartTime;
			},
			set(val: any) {				
				this.PlannerStartTime = val;				
				this.$emit('update:PlannerStartTime', val);
			},
		},
		EndPlannerTime: {
			get() {
				return this.PlannerEndTime;
			},
			set(val: any) {				
				this.PlannerEndTime = val;
				this.$emit('update:PlannerEndTime', val);
			},
		},

		StartLunchTime: {
			get() {
				return this.LunchStartTime;
			},
			set(val: any) {				
				this.LunchStartTime = val;				
				this.$emit('update:LunchStartTime', val);
			},
		},
		EndLunchTime: {
			get() {
				return this.LunchEndTime;
			},
			set(val: any) {				
				this.LunchEndTime = val;
				this.$emit('update:LunchEndTime', val);
			},
		},
		
		...genVuexComputeds(store),
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${types.mutations.DODAVATEL_SELECT_MAPPER}`,
				intrZakaznik: `${this.storeUri}/${types.mutations.INTR_ZAKAZNIK_SELECT_MAPPER}`,
				primaryBankList: `${this.storeUri}/${types.mutations.PRIMARY_BANK_SELECT_MAPPER}`,
				secondaryBankList: `${this.storeUri}/${types.mutations.SECONDARY_BANK_SELECT_MAPPER}`,
				dealerKVPSCode: `${this.storeUri}/${types.mutations.DEALERKVPS_SELECT_MAPPER}`,
			};
		},
		intrZakaznikFilter(): Record<string, any> {
			return {
				ZakaznikId: this.IntrZakaznikId,
				// TODO: API: upravit možnosti filtrování - typ partnera by měl jít nastavit na hodnotu 4
				// Needs to be commented till Internal Type is implemented on Customer Screen
				// PartnertypPzn: Partner.types.INTERNI,
			};
		},
		isDisabled():boolean {
			return this.pageMode === PageMode.EDIT;
		},
	},
	methods: {
		...mapMutationsDvm(store.mutations),

		ClearLunchHours() 
		{
			this.LunchStartTime = null;
			this.LunchEndTime = null;
		}
	},
});
